import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useIsChartererMovingForward = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const moveForward = async ({ requestId, body }) => {
    if (!token) throw new Error("Token is missing");
    if (!requestId) throw new Error("Request ID is required");
    
    console.log("moveForward called with requestId:", requestId);
    console.log("moveForward called with body:", body);
    
    // Prepare the body according to the API specification
    let requestBody = {};
    
    if (body.processed === true) {
      // If processed is true, include acceptPrice (can be true or false)
      requestBody = {
        processed: true,
        acceptPrice: body.acceptPrice !== undefined ? body.acceptPrice : true
      };
    } else {
      // If processed is false, include userMessage
      requestBody = {
        processed: false,
        userMessage: body.userMessage || ""
      };
    }

    const url = `${process.env.REACT_APP_SERVER_URL}/charter/charterer/isChartererMovingForward/${requestId}`;
    console.log("Making request to URL:", url);
    console.log("Request body:", requestBody);

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to update charter request");
    }

    return data;
  };

  const {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  } = useMutation(moveForward, {
    onSuccess: () => {
      // Invalidate and refetch charter requests to get updated data
      queryClient.invalidateQueries(["readAllCharterRequests"]);
      queryClient.invalidateQueries(["readCharterRequest"]);
    },
  });

  return {
    moveForward: mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};

export default useIsChartererMovingForward; 